import { Box, Text } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Modal } from 'uikit'
import { useResetUserIdentification } from './services/useResetUserIdentification'

export const ResetUserIdentification = ({ userId, isDisabled }) => {
  const { mutate, isLoading } = useResetUserIdentification(userId)
  const [isOpen, setOpenModal] = useBoolean(false)

  const handleSubmit = () => {
    mutate()
    setOpenModal(false)
  }

  return (
    <>
      <Button
        width="100%"
        onClick={() => setOpenModal(true)}
        colorPalette="orange"
        loading={isLoading}
        disabled={isDisabled}
      >
        Сбросить
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Сбросить идентификацию">
        <Text>Статус идентификации будет сброшен</Text>
        <Box pt="30px">
          <Button colorPalette="orange" loading={isLoading} onClick={handleSubmit}>
            Продолжить
          </Button>
        </Box>
      </Modal>
    </>
  )
}
